/**
 * Standard ReactPlayer config that disables download controls.
 */
export const VIDEO_PLAYER_CONFIG = {
  file: {
    attributes: {
      controlsList: 'nodownload',
    },
  },
}
